import AccordionItem from '~components/Accordion/AccordionItem'
import useAccordion from './hooks/useAccordion'
import { Props } from './interfaces'
import { getCustomToken } from '~utils/token'

function Accordion({ listAccordion, onChange }: Props) {
  const { accordionItems, changeOpenedAccordion } = useAccordion({ listAccordion, onChange })

  return (
    <>
      {accordionItems?.map((acc, index) => (
        <AccordionItem
          element={index}
          key={getCustomToken()}
          header={acc.header}
          isOpen={acc.isOpen}
          content={acc.content}
          onChange={() => changeOpenedAccordion(index)}
        />
      ))}
    </>
  )
}

export default Accordion
